import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

import { useDevice } from '@bonnet/next/device';

import { useFeatures } from '@atc/features';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

import VehicleFeaturesCarousel from './VehicleFeaturesCarousel';

function VehicleFeaturesContainer() {
    const {
        vehicle_highlight_specs: [enableVehicleHighlightSpecs],
    } = useFeatures([
        'vehicle_highlight_specs',
    ]);

    const listing = useSelector((state) => vdpResultsDuck.selectors.getVdpActiveInventory(state));
    const { features, packages = [], make = '', model = '', title = '', rankedFeatures } = listing;

    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);

    const sectionHeader = `Get to know this ${make?.name ?? make} ${model?.name ?? model}`;

    return (
        <VehicleFeaturesCarousel
            rankedFeatures={rankedFeatures}
            sectionHeader={isXs || !enableVehicleHighlightSpecs ? sectionHeader : null}
            packages={packages}
            features={features}
            vehicleTitle={title}
        />
    );
}

export default memo(VehicleFeaturesContainer, _isEqual);
